import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView, View } from "@frui.ts/views";
import { observer, Observer } from "mobx-react-lite";
import ModalService from "../services/modalService";

const rootView: ViewComponent<ModalService> = observer(({ vm }) => {
  return (
    <Observer>
      {() => (
        <>
          {vm.modals.map((item, i) => (
            <View key={i} vm={item} useLifecycle />
          ))}
        </>
      )}
    </Observer>
  );
});

registerView(rootView, ModalService);
